import { ASPECT_RATIO, gridPhotos } from '@app/components/package-customize/customize-sheet-item/sheet/utils';

export default {
  nameDesc: '1 - 5x7, 9 - 1x2',
  imageCount: 10,
  displayGroup: 'DG_5X7_WALLET',
  calc: (height) => {
    const p1Width = height / ASPECT_RATIO / 3;
    const p1Height = height / 3;
    const p10Width = height / ASPECT_RATIO;
    const p10Height = height;

    return {
      gridTemplate: `
        'p1 p2 p3 p10' ${p1Height}px
        'p4 p5 p6 p10' ${p1Height}px
        'p7 p8 p9 p10' ${p1Height}px
        / ${p1Width}px ${p1Width}px ${p1Width}px ${p10Width}px`,
      photos: [
        ...gridPhotos(1, 9, p1Width, p1Height),
        {
          gridArea: 'p10',
          width: p10Width,
          height: p10Height
        }
      ]
    };
  }
};
